import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMAcademyLinkResource {
  
  static getAcademyLinks(query, completion){
    const q = SMFormatHelper.getUrlArgString(query);
    const apiClient = new SMRestClient();
    apiClient.get("/1/academy_links.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
}
export default SMAcademyLinkResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMAcademyLinkResource.js